import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OrderProvider } from '../providers/order.provider';
import { SelectedProductInterface } from '../data';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface AcceptOrderSignatoriesUseCaseParams {
    product: SelectedProductInterface;
}

@Injectable()
export class AcceptOrderSignatoriesUseCase implements UseCaseWithParam<AcceptOrderSignatoriesUseCaseParams, Observable<Transaction<void>>> {
    constructor(private orderProvider: OrderProvider) {}

    bind(params: AcceptOrderSignatoriesUseCaseParams): Observable<Transaction<void>> {
        return this.orderProvider.acceptSignatories(params.product);
    }
}
